import { deepMerge } from './utils';
import { resolveJwtToken } from './authStore';

import type { ClientEmbedderInfo, WorknetWidgetConfig } from '@worknet/models';
import type { DeepPartial } from './utils';

export function getWorknetWidgetConfig(): WorknetWidgetConfig {
  const urls = getUrls();
  const windowConfig = window.__WorknetWidget ?? {};

  const defaults: DeepPartial<WorknetWidgetConfig> = {
    apiBaseUrl: urls.apiBaseUrl,
    chatBaseUrl: urls.chatBaseUrl,

    styles: {
      primary: '#587aff',
      secondary: '#ffffff',
      tertiary: '#ffffff',
      topOffset: '0px',
      width: '600px',
      zIndex: 9999,
      bubbleZIndex: undefined,
      side: 'right',
    },

    button: {
      isHidden: false, // even if needs button according to llm, it is hidden (embedder has button of its own)
      icon: 'chat',
      isColorsReversed: false,
      text: undefined,
    },

    chat: {
      isDrawer: true,
      linkTarget: '_blank',
      header: {
        text: 'Smart Assistance',
      },
      footer: {
        isHidden: false,
        text: 'Powered by',
        privacyPolicyText: '',
        privacyPolicyUrl: '',
      },
    },

    nudgeBox: {
      maxWidthCenter: '800px',
      maxWidthSide: '600px',
      maxWidthTooltip: '600px',
    },
  };

  const mergedConfig = deepMerge(defaults, windowConfig) as WorknetWidgetConfig;

  return {
    ...mergedConfig,
    jwt: resolveJwtToken(mergedConfig.jwt),
  } as WorknetWidgetConfig;
}

// export function getWidgetConfig(): WidgetConfig {
//   const windowConfig = window.__WorknetWidget ?? {};
//   const initialState = windowConfig.initialState;
//   const buttonSide = windowConfig.buttonSide;
//   const urls = getUrls();

//   const config: WidgetConfig = {
//     chatBaseUrl: windowConfig.chatBaseUrl ?? urls.chatBaseUrl,
//     apiBaseUrl: windowConfig.apiBaseUrl ?? urls.apiBaseUrl,

//     widgetKey: windowConfig.widgetKey ?? '',

//     groupingId: windowConfig.groupingId ?? '',

//     notificationHint: windowConfig.notificationHint ?? '', // TODO: remove, legacy

//     showDialog: parseBoolLike(windowConfig.showDialog, false), // TODO: remove, should come from load

//     headerText: windowConfig.headerText ?? 'Smart Assistance',
//     buttonSide: buttonSide?.toLowerCase() === 'left' ? 'left' : 'right',
//     buttonText: windowConfig.buttonText ?? undefined,
//     buttonIcon: windowConfig.buttonIcon ?? 'chat',

//     initialState:
//       initialState && widgetStates.includes(initialState as WidgetState)
//         ? (initialState as WidgetState)
//         : 'button', // TODO: remove, should come from load

//     isDrawer: parseBoolLike(windowConfig.isDrawer, true),
//     isButtonColorsReversed: parseBoolLike(windowConfig.isButtonColorsReversed, false),
//     isButtonHidden: parseBoolLike(windowConfig.isButtonHidden, false),
//     styles: {
//       primary: windowConfig.styles?.primary ?? '#587aff',
//       secondary: windowConfig.styles?.secondary ?? '#ffffff',
//       tertiary: windowConfig.styles?.tertiary ?? '#ffffff',
//       topOffset: normalizeCssLengthValue(windowConfig.styles?.topOffset),
//       width: normalizeCssLengthValue(windowConfig.styles?.width, '600px'),
//       zIndex: Number(windowConfig.styles?.zIndex) || 9999,
//     },
//     footerOptions: {
//       showFooter: parseBoolLike(windowConfig.footerOptions?.showFooter, true),
//       footerText: windowConfig.footerOptions?.footerText ?? 'Powered by',
//       privacyPolicyText: windowConfig.footerOptions?.privacyPolicyText ?? '',
//       privacyPolicyUrl: windowConfig.footerOptions?.privacyPolicyUrl ?? '',
//     },
//     customContext: windowConfig.customContext ?? {},
//   };

//   const isCustomTrigger = parseBoolLike(
//     (windowConfig as unknown as { isCustomTrigger?: boolean })?.isCustomTrigger,
//     false
//   );
//   return Object.assign(config, { __isCustomTrigger: isCustomTrigger }) as WidgetConfig & {
//     __isCustomTrigger?: boolean;
//   };
// }

// function normalizeCssLengthValue(v?: string, defaultVal = '0px') {
//   if (!v) {
//     return defaultVal;
//   }
//   const trimmed = v.trim();
//   if (/^\d+$/.test(trimmed)) {
//     return `${trimmed}px`;
//   }
//   const num = parseFloat(trimmed);
//   if (!isFinite(num) || num < 0) {
//     return defaultVal;
//   }
//   return trimmed;
// }

const baseUrl = import.meta.env.BASE_URL;
function getUrls() {
  const scriptUrl = import.meta.url.startsWith('http://localhost:')
    ? 'https://dev.app.worknet.ai/chat-widget/embed.js'
    : import.meta.url;

  const chatBaseUrl = new URL(`${baseUrl}`, scriptUrl);

  const apiBaseUrl = new URL(`${baseUrl}`, scriptUrl);
  apiBaseUrl.hostname = apiBaseUrl.hostname.replace('app', 'api');

  return {
    apiBaseUrl: apiBaseUrl.toString().replace(/\/+$/, ''),
    chatBaseUrl: chatBaseUrl.toString().replace(/\/+$/, ''),
  };
}

export function getClientEmbedderInfo(deviceId: string): ClientEmbedderInfo {
  return {
    deviceId,

    referrerUrl: document.referrer,
    currentUrl: window.location.href,

    language: navigator.language,
    languages: Array.from(navigator.languages),
    timezone: Intl?.DateTimeFormat().resolvedOptions().timeZone,

    screen: {
      width: screen.width,
      height: screen.height,
      colorDepth: screen.colorDepth,
      pixelRatio: window.devicePixelRatio,
    },

    viewport: {
      width: window.innerWidth,
      height: window.innerHeight,
    },

    deviceCategory: window.innerWidth <= 768 ? 'mobile' : 'desktop',
  };
}
